function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1956(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.81,
    height: 9.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.16875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 4.675
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.35,
    width: 22.81,
    height: 22.42,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 20.560000000000002
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.77,
    width: 22.81,
    height: 28.8,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.561999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 46.17
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.58,
    width: 22.81,
    height: 31.18,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.561999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 76.17
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.76,
    width: 22.81,
    height: 36.56,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5344444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 110.04
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.31,
    width: 22.81,
    height: 42.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8016666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 149.56
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.81,
    width: 22.81,
    height: 45.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.561999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 193.735
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.67,
    width: 22.81,
    height: 46.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2585714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 239.915
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.16,
    width: 22.81,
    height: 48.12,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2585714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 287.22
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311.27,
    width: 22.81,
    height: 51.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.561999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 336.945
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362.63,
    width: 22.81,
    height: 53.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8016666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 389.275
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 415.91,
    width: 22.81,
    height: 53.57,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 442.69500000000005
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 469.48,
    width: 22.81,
    height: 54.71,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8016666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 496.83500000000004
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.19,
    width: 22.81,
    height: 55.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 551.7800000000001
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.37,
    width: 22.81,
    height: 59.74,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 609.24
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 639.1,
    width: 22.81,
    height: 60.9,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.405,
    y: 669.5500000000001
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 0,
    width: 34.62,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4619999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.12,
    y: 20.46
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.43,
    y: 0,
    width: 35.78,
    height: 40.92,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.32,
    y: 20.46
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.21,
    y: 0,
    width: 36.7,
    height: 40.92,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.116666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.56,
    y: 20.46
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.91,
    y: 0,
    width: 39.04,
    height: 40.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.577142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.43,
    y: 20.46
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.95,
    y: 0,
    width: 39.26,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9259999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.57999999999998,
    y: 20.46
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.21,
    y: 0,
    width: 39.6,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.01000000000002,
    y: 20.46
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.81,
    y: 0,
    width: 39.83,
    height: 40.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.725,
    y: 20.46
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.64,
    y: 0,
    width: 40.51,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.06375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.895,
    y: 20.46
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 0,
    width: 41.51,
    height: 40.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.895,
    y: 20.46
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.65,
    y: 0,
    width: 41.82,
    height: 40.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.56,
    y: 20.46
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.48,
    y: 0,
    width: 42.41,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.685,
    y: 20.46
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.88,
    y: 0,
    width: 42.57,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.165,
    y: 20.46
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.45,
    y: 0,
    width: 48.69,
    height: 40.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.184000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.795,
    y: 20.46
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.14,
    y: 0,
    width: 50.7,
    height: 40.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.845714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.49,
    y: 20.46
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.84,
    y: 0,
    width: 51.79,
    height: 40.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.735,
    y: 20.46
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.62,
    y: 0,
    width: 52.38,
    height: 40.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.8100000000001,
    y: 20.46
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 40.92,
    width: 58.51,
    height: 41.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7436363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 61.510000000000005
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 82.1,
    width: 58.51,
    height: 43.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 103.8
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 125.5,
    width: 58.51,
    height: 44.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 147.975
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 170.45,
    width: 58.51,
    height: 45.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0344444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 193.105
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 215.75,
    width: 58.51,
    height: 49.41,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.17625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 240.45499999999998
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 265.16,
    width: 58.51,
    height: 50.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 290.41
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 315.66,
    width: 58.51,
    height: 51.15,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.307142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 341.235
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 366.81,
    width: 58.51,
    height: 52.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.564285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 393.285
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 419.76,
    width: 58.51,
    height: 56.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 448.05
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 476.34,
    width: 58.51,
    height: 66.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.751666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 509.59499999999997
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 542.85,
    width: 58.51,
    height: 76.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.851
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 580.87
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.81,
    y: 618.89,
    width: 58.51,
    height: 81.11,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.065,
    y: 659.4449999999999
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 40.92,
    width: 60.3,
    height: 85.3,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.47,
    y: 83.57
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.63,
    y: 40.92,
    width: 61.28,
    height: 85.3,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.128
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.26999999999998,
    y: 83.57
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.91,
    y: 40.92,
    width: 64.95,
    height: 85.3,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.904545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.385,
    y: 83.57
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.87,
    y: 40.92,
    width: 67.95,
    height: 85.3,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.49375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.845,
    y: 83.57
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.82,
    y: 40.92,
    width: 73.06,
    height: 85.3,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.176666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.35,
    y: 83.57
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.87,
    y: 40.92,
    width: 74.96,
    height: 85.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.708571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.35,
    y: 83.57
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.83,
    y: 40.92,
    width: 92.96,
    height: 85.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.31,
    y: 83.57
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.79,
    y: 40.92,
    width: 123.21,
    height: 85.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.395,
    y: 83.57
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 126.21,
    width: 127.09,
    height: 102.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.75375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.865,
    y: 177.225
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 228.24,
    width: 127.09,
    height: 117.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.784285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.865,
    y: 286.985
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 345.73,
    width: 127.09,
    height: 149.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.18166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.865,
    y: 420.42
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 495.11,
    width: 127.09,
    height: 204.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.553636363636365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.865,
    y: 597.5550000000001
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.41,
    y: 126.21,
    width: 141.16,
    height: 224.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.99,
    y: 238.635
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.57,
    y: 126.21,
    width: 165.67,
    height: 224.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.611666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.405,
    y: 238.635
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.25,
    y: 126.21,
    width: 184.75,
    height: 224.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.625,
    y: 238.635
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.41,
    y: 351.06,
    width: 290.03,
    height: 161.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.1875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.42499999999995,
    y: 431.81
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.41,
    y: 512.56,
    width: 290.03,
    height: 187.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.42499999999995,
    y: 606.28
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.45,
    y: 351.06,
    width: 201.55,
    height: 348.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.225,
    y: 525.53
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1956);
export default __webpack_public_path__ + "static/media/1956.9cd4ffd506db3529348cd21f058c812d.svg";
export { ForwardRef as ReactComponent };